import { format, isFuture, isValid, parse } from 'date-fns';

import * as server from './formatDateServer';

export const DATE_FORMAT = 'MMMM dd, yyyy';
export const TIME_FORMAT = 'h:mm aaa';

export const formatDate = (dateString: string) => {
  if (!dateString) {
    return '';
  }

  const normalizedDateString = dateString.includes('T') ? dateString.split('T')[0] : dateString;
  const date = parse(normalizedDateString, server.DATE_FORMAT, new Date());

  try {
    const formatted = format(date, DATE_FORMAT);
    return formatted;
  } catch {
    return '';
  }
};

export const formatDateTime = (dateString: string) => {
  const emptyResult = { date: '', time: '' };

  if (!dateString) {
    return emptyResult;
  }

  const date = parse(dateString, server.DATE_TIME_FORMAT, new Date());

  if (!isValid(date)) {
    return emptyResult;
  }

  return {
    date: format(date, DATE_FORMAT),
    time: format(date, TIME_FORMAT),
  };
};

export const formatStartEndDateTime = (
  startDateTime: string,
  endDateTime: string,
  displayDate: string
): {
  date: string;
  time: string;
  display: string;
  dateOnlyDisplay: string;
} => {
  if (displayDate) {
    return { date: '', time: '', display: displayDate, dateOnlyDisplay: displayDate };
  }

  const start = formatDateTime(startDateTime);
  const end = formatDateTime(endDateTime);

  const delimiter = '  |  ';

  if (!start.date && !end.date) {
    return { date: '', time: '', display: '', dateOnlyDisplay: '' };
  } else if (start.date && !end.date) {
    return {
      ...start,
      display: `${start.date}${delimiter}${start.time}`,
      dateOnlyDisplay: start.date,
    };
  } else if (!start.date && end.date) {
    return {
      ...end,
      display: `${end.date}${delimiter}${end.time}`,
      dateOnlyDisplay: end.date,
    };
  } else {
    if (start.date === end.date) {
      return {
        date: start.date,
        time: `${start.time} - ${end.time}`,
        display: `${start.date}${delimiter}${start.time} - ${end.time}`,
        dateOnlyDisplay: start.date,
      };
    } else {
      return {
        date: '',
        time: '',
        display: `${start.date}, ${start.time} - ${end.date}, ${end.time}`,
        dateOnlyDisplay: `${start.date} - ${end.date}`,
      };
    }
  }
};

export const isFutureEvent = (startDateTime: string, endDateTime: string) => {
  const date = endDateTime || startDateTime;

  if (!date) {
    return false;
  }

  const eventDate = new Date(date);

  if (!isValid(eventDate)) {
    return false;
  }
  return isFuture(eventDate);
};

export const formatDateForCalendar = (dateString: string) => {
  if (!dateString) {
    return '';
  }

  const date = new Date(dateString);

  if (!isValid(date)) {
    return '';
  }

  return format(date, 'yyyy-MM-dd');
};

export const formatTimeForCalendar = (dateString: string) => {
  if (!dateString) {
    return '';
  }

  const date = new Date(dateString);

  if (!isValid(date)) {
    return '';
  }

  return format(date, 'HH:mm');
};
